import { useTranslation } from 'react-i18next';
import type { SupportTranslation } from '../types';

export function useSupportTranslation() {
  const { t, i18n } = useTranslation('support');

  return {
    t,
    currentLanguage: i18n.language,
    changeLanguage: i18n.changeLanguage,
    isRTL: i18n.dir() === 'rtl',
    getSupportTranslation: (): SupportTranslation => ({
      title: t('title'),
      subtitle: t('subtitle'),
      plans: {
        basic: {
          name: t('plans.basic.name'),
          description: t('plans.basic.description'),
          features: t('plans.basic.features', { returnObjects: true })
        },
        premium: {
          name: t('plans.premium.name'),
          description: t('plans.premium.description'),
          features: t('plans.premium.features', { returnObjects: true })
        },
        platinum: {
          name: t('plans.platinum.name'),
          description: t('plans.platinum.description'),
          features: t('plans.platinum.features', { returnObjects: true })
        }
      },
      customSupport: {
        text: t('customSupport.text'),
        buttonText: t('customSupport.buttonText')
      }
    })
  };
}